import { AfterContentChecked, ChangeDetectorRef, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TokenInterceptor } from './core/auth/interceptors/token-interceptor.service';
import { SpinnerService } from './services/spinner/spinner.service';

@Component({
  selector: 'lns-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterContentChecked {
  loading$ = this.spinner.loading$;
  title = 'leonus-admin';
  constructor(
    private translate: TranslateService, 
    private spinner:SpinnerService,
    private interceptor: TokenInterceptor,
    private ref: ChangeDetectorRef
    ) {
    this.translate.addLangs(['en']);
    const currentLang = localStorage.getItem('language')
      ? localStorage.getItem('language')
      : 'en';
    this.translate.setDefaultLang(currentLang);
  }
  ngAfterContentChecked() {
    this.ref.detectChanges();
  }
}
